import React, { useState } from 'react';
import styles from './JoinRoom.module.css';

interface JoinRoomProps {
  onBack: () => void;
  onJoin: (roomCode: string) => Promise<void>;
  loading: boolean;
  error: string | null;
}

export const JoinRoom: React.FC<JoinRoomProps> = ({ 
  onBack, 
  onJoin, 
  loading, 
  error 
}) => {
  const [roomCode, setRoomCode] = useState('');
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (roomCode.trim().length === 6) {
      onJoin(roomCode.trim().toUpperCase());
    }
  };
  
  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (value.length <= 6) {
      setRoomCode(value);
    }
  };
  
  return (
    <div className={styles.container}>
      <form onSubmit={handleSubmit} className={styles.form}>
        <h3 className={styles.title}>Join Room</h3>
        
        <div className={styles.inputGroup}>
          <label htmlFor="roomCode" className={styles.label}>
            Room Code
          </label>
          <input
            id="roomCode"
            type="text"
            placeholder="Enter 6-character code"
            value={roomCode}
            onChange={handleCodeChange}
            className={styles.input}
            autoFocus
            autoComplete="off"
            spellCheck="false"
          />
          <p className={styles.hint}>
            Ask your friend for the room code
          </p>
        </div>
        
        <div className={styles.actions}>
          <button 
            type="button"
            onClick={onBack} 
            className={`${styles.button} ${styles.secondaryButton}`}
            disabled={loading}
          >
            Back
          </button>
          <button 
            type="submit"
            className={`${styles.button} ${styles.primaryButton}`}
            disabled={loading || roomCode.length !== 6}
          >
            {loading ? 'Joining...' : 'Join Room'}
          </button>
        </div>
        
        {error && <p className={styles.error}>{error}</p>}
      </form>
    </div>
  );
};